import React, { useContext, useEffect, useState } from "react";
import { Formik, Form } from "formik";

import styled from "styled-components";
import { Body, BodyStyles, Header2 } from "../components/typography";
import TextInput from "../components/TextInput";
import { Colors } from "../components/styles/Colors";
import LoadingButton from "../components/LoadingButton";
import RECOVER_CUSTOMER from "../queries/forgotPassword";
import { useMutation } from "@apollo/client";
import { Helmet } from "react-helmet";
import { store } from "../utils/StoreContext";
import { navigate, Link } from "gatsby";

const Wrapper = styled.div`
  background: ${Colors.cream2};
`;

const LoginBox = styled.div`
  text-align: center;

  padding: 64px 32px;

  ${Header2} {
    margin-bottom: 30px;
  }

  form {
    max-width: 400px;
    margin: 0 auto;
  }

  form > div {
    margin: 10px 0;
  }
`;

const LinkText = styled(Link)`
  ${BodyStyles}

  font-size: 14px;
  line-height: 1.25;

  text-align: center;

  margin: 20px 0;

  color: ${Colors.grey};
  text-decoration: none;
`;

const ErrorText = styled.p`
  ${BodyStyles}

  font-size: 14px;
  line-height: 1.25;

  color: ${Colors.red};

  text-align: center;

  margin: 20px 0;
`;

const initialValues = {
  email: "",
  password: "",
};

const ERROR_MAP = {
  UNIDENTIFIED_CUSTOMER:
    "We weren't able to find a user with that email and password. Please contact us at hello@mantl.co if you need assistance editing your subscription.",
};

export default function ResetPassword() {
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [forgot, { loading }] = useMutation(RECOVER_CUSTOMER);

  function onSubmit(values) {
    setSubmitted(false);
    setError(null);

    return forgot({ variables: { email: values.email } }).then(({ data }) => {
      if (data.recoverCustomer) {
        setSubmitted(true)
      } else {
        setSubmitted(false)
        setError("UNIDENTIFIED_CUSTOMER");
      }
    });
  }

  return (
    <Wrapper>
      <Helmet>
        <title>Forgot your password?</title>
      </Helmet>
      <LoginBox>
        <Header2>Forgot your password?</Header2>
        {submitted ? <Body>If you have a user registered with this email, we've sent you a reset confirmation email.</Body> : <Formik initialValues={initialValues} onSubmit={onSubmit}>
          <Form>
            <TextInput name="email" label="Email" />
            <LoadingButton loading={loading}>Reset Password</LoadingButton>
            {error && <ErrorText>{ERROR_MAP[error]}</ErrorText>}
            <div>
              <LinkText to="/account">Login</LinkText>
            </div>
          </Form>
        </Formik> }
      </LoginBox>
    </Wrapper>
  );
}
